module.exports = __webpack_public_path__ + "img/clear sky.07b6d7fe.jpg";